/**
 * Sync fetch of candidates by ids
 * @param {object} api - The axios instance
 * @param {string[]} ids
 * @returns {Array<Candidate>}
 */
export default async function fetchCandidatesByIds(api, ids) {
  if (!ids.length) {
    return [];
  }

  try {
    const { data } = await api.get("/candidates/ids", {
      params: {
        ids,
      },
    });
    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
}
